import React from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { Link, useHistory } from "react-router-dom";

import "./auth.css";

import Button from "app/components/button/Button";
// import ThemeSwitcher from "app/styles/theme/ThemeSwitcher";
// import LanguageSwitcher from "app/translations/LanguageSwitcher";
import { getErrorMessage, regexForMobileNumber } from "app/utils";
import { DOWNLOAD_IMAGE, FORGOT_PASSWORD } from "app/api/ApiEndpoints";
import { usePost } from "app/services/http-service";
import { StoreContext } from "app/context/Store";
import Alert from "app/components/alert/Alert";
import useAlertConfig from "app/hooks/useAlertConfig";

function ForgotPassword(props) {
  const { alertConfig, showSuccessAlert, showFailureAlert} = useAlertConfig(6);
  const history = useHistory();
  const { state } = React.useContext(StoreContext);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const {
    mutate: forgotPasswordMutation,
    isLoading: isSendingMail,
    isSuccess: successfullySent,
  } = useMutation((data) => usePost(data),{
    onSuccess:()=>{
      showSuccessAlert("Successfully sent Forget password link on your email address");
    },
    onError:(error)=>{
      showFailureAlert(error.message ? error.message : "Something went wrong!");
    }

  });

  const onSubmit = (data) => {
    const body = {
      url: FORGOT_PASSWORD,
      token: null,
      data: {
        username: data.mobileNumber,
      },
    };
    forgotPasswordMutation(body);
  };

  React.useEffect(() => {
    if (successfullySent) {
      setTimeout(() => {
        history.push("/auth/login");
      }, 2000);
    }
  }, [successfullySent]);

  return (
    <>
      <div className="login-wrapper">
        {alertConfig && (
          <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
        )}
        <div className="row no-gutters">
          <div className="col-md-6">
            <div className="left_side">
              <h1 className="banner_head text-uppercase">
                One Gateway, Many Solutions
              </h1>
              {/* <div className="switchers">
                <div className="theme-switcher">
                  <ThemeSwitcher />
                </div>
                <div className="lang-switcher">
                  <LanguageSwitcher />
                </div>
              </div> */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="right_side">
              <div className="text-center">
                <img
                  src={DOWNLOAD_IMAGE +'?key='+ state?.clientConfigData?.logo}
                  alt="client-logo"
                  className="client-logo"
                />
              </div>
              <div id="login-form">
                <h2 className="text-center py-4">Forget Password</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter your Mobile Number"
                      name="mobileNumber"
                      {...register("mobileNumber", {
                        required: true,
                        minLength: 10,
                        maxLength: 10,
                        pattern: regexForMobileNumber,
                      })}
                    />
                    <p className="mt-1 text-danger">
                      {getErrorMessage(errors, "mobileNumber", "Mobile Number")}
                    </p>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="*"
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="*"
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="*"
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="*"
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="*"
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="*"
                      />
                    </div>
                  </div> */}
                  <p className="text-right">
                    <Link to={`/auth/login?tenant-name=${props.location.state}`} className="link_text font_600">
                      Back to login
                    </Link>
                  </p>
                  <div className="clearfix"></div>
                  <Button className="button btn-primary">
                    {isSendingMail ? "Sending" : "Send OTP"}
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
